export function getParams (state){
    return state.params
}
export function getCategories(state){
    return state.category
}



// WEBPACK FOOTER //
// ./src/modules/documents/getters.js